// -----------------------------------------------------------------------------------------------------------------
//------------------------------------------------- For Explore Page------------------------------------------------
// -----------------------------------------------------------------------------------------------------------------

import p1 from '../assets/images/HomePage/p 01.png';
import p5 from '../assets/images/HomePage/p 05.png';
import disNFT_profile_pic from '../assets/images/HomePage/disNFT_profile_pic.png';

import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';
import collectionLogo from '../assets/images/explore/colectionLogo.png';
import creatorLogo from '../assets/images/explore/creator.png';

import slide_thumb01 from '../assets/images/HomePage/slide_thumb01.png';
import slide_thumb02 from '../assets/images/HomePage/slide_thumb02.png';




export interface nftsDataType {
    id: number,
    profiles: string[],
    thumb: string,
    time: string,
    timeShow: boolean,
    title: string,
    discription: string,
    creator: {
        royalties: string,
        logo: string,
        title: string,
    },
    collection: {
        logo: string,
        name: string,
    },
    owners: {
        id: number,
        ownerLogo: string,
        name: string,
    }[],
    bids: {
        bidLogo: string,
        bidTitle: string,
        time: string,
    }[],
    details: string,
    transactionHistory: {
        id: number,
        ammount: number,
        growing: boolean,
        time: string,
        token: string,
    }[],
    currentBid: {
        ethPrice: number,
        mainPrice: number,
    },
    author: string,
    authorShow: boolean,
    price: number,
    aMA: number,


    nftPostData: {
        profilePic: string,
        comments: {
            id: number,
            profLogo: string,
            commTitle?: string,
            commPhoto?: string,
            commAudio?: string,
            time: string,
        }[],
        loves: number,
        isMyloves?: boolean,
        shares: number,
    },
}

export const exploreEtherData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]


export const liveAutionsData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]


export const buyNFTsData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]


export const mintNFTsData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]







export const hotBidsNFTData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]



export const onSaleNftData: nftsDataType[] = [
    {
        id: 18,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jul 24, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,
        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 1,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 2,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 3,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 4,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 5,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 6,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 7,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 22, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 8,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 26, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 9,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 28, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: true,
        price: 4.89,
        aMA: 6,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 10,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 29, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids',
        authorShow: true,
        price: 4.89,
        aMA: 4,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 11,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 27, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 12,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 23, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 13,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: true,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
    {
        id: 14,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 25, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 15,
        profiles: [p1, p5, p1],
        thumb: slide_thumb02,
        time: 'Jun 20, 2022 00:00:00',
        timeShow: false,
        title: 'Lucky cat maneki neko',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Open for bids ',
        authorShow: true,
        price: 4.89,
        aMA: 5,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 16,
        profiles: [p1, p5, p1],
        thumb: slide_thumb01,
        time: 'Jun 30, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
        }
    },
    {
        id: 17,
        profiles: [p1, p5, p1],

        thumb: slide_thumb01,
        time: 'Jun 21, 2022 00:00:00',
        timeShow: false,
        title: 'Hamlet Contemplat',
        discription: 'is one of the  collection of 10000 unique, randomly generated wild boars roaming on the Ethereum blockchain.',
        creator: {
            royalties: '5% royalties',
            logo: creatorLogo,
            title: 'Kitty world',
        },
        collection: {
            logo: collectionLogo,
            name: 'UNC',
        },
        owners: [
            {
                id: 1,
                ownerLogo: bid1,
                name: 'Benjamin 1',
            },
            {
                id: 2,
                ownerLogo: bid2,
                name: 'Benjamin 2',
            },
            {
                id: 3,
                ownerLogo: bid3,
                name: 'Benjamin 3',
            },
            {
                id: 4,
                ownerLogo: bid1,
                name: 'Benjamin 4',
            },
            {
                id: 5,
                ownerLogo: bid2,
                name: 'Benjamin 5',
            },
            {
                id: 6,
                ownerLogo: bid3,
                name: 'Benjamin 6',
            },
        ],
        bids: [
            {
                bidLogo: bid1,
                bidTitle: '0.003 wETH by Nft bank for 1 edition',
                time: '3 minutes ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.001 wETH by Jatinder Parmar for 1 edition',
                time: '43 minutes ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 1 edition',
                time: '2 hours ago',
            },
            {
                bidLogo: bid3,
                bidTitle: '0.001 wETH by  Geasnder Gemar for 2 edition',
                time: '3 hours ago',
            },
            {
                bidLogo: bid2,
                bidTitle: '0.005 wETH by Jatinder Parmar for 5 edition',
                time: '5 minutes ago',
            },
        ],
        details: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates recusandae, aliquid voluptatem praesentium perspiciatis nostrum voluptatibus doloremque iusto ab unde earum, quasi odio harum esse ipsa tempore, sunt alias atque!',
        transactionHistory: [
            {
                id: 1,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 2,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 3,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 4,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 5,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 6,
                ammount: 0.009,
                growing: true,
                time: '43 minutes ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
            {
                id: 7,
                ammount: 0.007,
                growing: true,
                time: '2 hours ago',
                token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
            },
            {
                id: 8,
                ammount: 0.3,
                growing: false,
                time: '4 hours ago',
                token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
            },
            {
                id: 9,
                ammount: 0.00945,
                growing: true,
                time: '5 hours ago',
                token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
            },
            {
                id: 10,
                ammount: 0.009,
                growing: true,
                time: '5 hours ago',
                token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
            },
        ],
        currentBid: {
            ethPrice: 0.032,
            mainPrice: 97,
        },
        author: 'Auction',
        authorShow: false,
        price: 4.89,
        aMA: 1,

        nftPostData: {
            profilePic: disNFT_profile_pic,
            comments: [
                {
                    id: 1,
                    profLogo: bid1,
                    commTitle: 'Nice work bro',
                    time: '2022-05-08 10:07:21',
                },
                {
                    id: 2,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams',
                    time: '2022-05-05 10:07:21',
                },
                {
                    id: 3,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-05 02:07:21',
                },
                {
                    id: 4,
                    profLogo: bid1,
                    commTitle: 'Nice work bro 22222',
                    time: '2022-05-04 10:07:21',
                },
                {
                    id: 5,
                    profLogo: bid2,
                    commTitle: 'Liked  by Autistic dreams 2',
                    time: '2022-05-03 10:07:21',
                },
                {
                    id: 6,
                    profLogo: bid3,
                    commTitle: 'Liked  by Autistic dreams 3',
                    commPhoto: 'https://media2.giphy.com/media/mxjzBpyu8DDLIcEKVC/giphy-preview.gif?cid=7b4b543f6tq5ubo3zj3k8md32t24rysx0drxebxjuf51pu0k&rid=giphy-preview.gif&ct=g',
                    time: '2022-05-02 10:07:21',
                },
            ],
            loves: 1234,
            shares: 33,
            isMyloves: true,
        }
    },
]
